import { call, put, take, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';

import { browserHistory } from 'react-router';
import { ERROR_CODES, DASHBOARD_RECORD_ERROR } from '../../../constants/errors';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { consts as recordConstants, actions as recordActions } from '../record';
import * as validatePatientInfoReq from '../requests/validate-patient-info-req';
import {
  DASHBOARD_RECORD,
  DASHBOARD_VISIT_INFO,
} from '../../../constants/routes';

export function* savePatientInfoWorker(action) {
  const {
    payload: { data: patient },
  } = action;

  yield put(validatePatientInfoReq.actions.send({ patient }));

  const { type, payload } = yield take([
    validatePatientInfoReq.consts.SUCCEED,
    validatePatientInfoReq.consts.REJECTED,
  ]);

  if (type === validatePatientInfoReq.consts.REJECTED) {
    yield call(handlePatientInfoError, payload);
  } else {
    yield put(recordActions.savePatientInfo(patient));
    browserHistory.push(`${DASHBOARD_RECORD}/${DASHBOARD_VISIT_INFO}`);
  }
}

function* handlePatientInfoError(payload) {
  const code = get(payload, 'error.code');
  const user = get(payload, 'error.meta.otherUserName');

  switch (code) {
    case ERROR_CODES.DASHBOARD_LOGIN_TAKEN: {
      const loginType = get(payload, 'error.meta.loginType');
      const fieldName =
        loginType === PROFILE_FIELDS_TYPES.EMAIL ? 'Email' : 'Phone';

      const messageId = {
        id: DASHBOARD_RECORD_ERROR[code],
        values: {
          name: user,
          field: fieldName,
        },
      };
      return yield put(recordActions.savePatientInfoError(messageId));
    }

    case ERROR_CODES.DASHBOARD_SSN_TAKEN: {
      const messageId = DASHBOARD_RECORD_ERROR[code];

      return yield put(
        recordActions.savePatientInfoError({
          id: messageId,
          values: {
            name: user,
          },
        }),
      );
    }

    case ERROR_CODES.RECORD_INVALID: {
      return yield put(recordActions.saveCommonErrors(get(payload, 'error')));
    }

    default: {
      yield put(
        recordActions.savePatientInfoError({
          id: 'common.error',
        }),
      );
    }
  }
}

export default function* savePatientInfoSaga() {
  yield takeLatest(
    recordConstants.VALIDATE_PATIENT_INFO,
    savePatientInfoWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/save-patient-info-saga.js